<div id="download-report-modal-root" *transloco="let t">
  <div class="header">
    <app-header>
      {{ t('download-reports') }}
    </app-header>
    <button
      id="close-download-report-icon"
      (click)="onCloseClick()"
      mat-icon-button
      class="close-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <p style="padding: 1rem 0 1rem 0">{{ t('choose-date-range') }}</p>
  <div>
    <app-radio
      [options]="rangeOptions"
      (emitOption)="onOptionSelected($event)"
    ></app-radio>
    <br />
    <app-date-range-picker
      class="date-range-picker"
      [ngClass]="{'invalid-field': isDateRangeInvalid()}"
      *ngIf="isDisplayDateRange"
      (dateRange)="onDateRangeSelected($event)"
    ></app-date-range-picker>
    <mat-error *ngIf="isDateRangeInvalid()">{{ t('this-field-is-required') }}</mat-error>
  </div>
  <div class="button-area">
    <app-primary-button
      mat-raised-button
      (clickAction)="onCloseClick()"
      v2Outlined
      class="cancel"
      >{{ t('cancel') }}</app-primary-button
    >
    <app-primary-button
      [disabled]="isDisabled"
      mat-raised-button
      (clickAction)="onSuccessClick()"
      v2Full
      class="download-report-button"
      >{{ t('download') }}</app-primary-button
    >
  </div>
</div>
